import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { tokenAddress } from "../Web3/Constents";
import { AppContext } from "../AppContext";
import axios from "axios";

const MORALIS_API_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJub25jZSI6IjdhYzY0M2YwLTA5NWMtNDM5MC04ZmE5LWVlNmFlYTBkNDAxNSIsIm9yZ0lkIjoiNTExNTk5IiwidXNlcklkIjoiNTI2NDI1IiwidHlwZUlkIjoiODA3M2VhZmItMjQ3My00NGU1LTg2OGItMjE0NWEyMDZiZTg4IiwidHlwZSI6IlBST0pFQ1QiLCJpYXQiOjE3NzY3NjQ3NjEsImV4cCI6NDkzMjUyNDc2MX0.HOYQNYQQgLAu11Kn9xAE6kab92iT3ANz7LoIGbG4SHg';

export default function TableUI() {
  const [data, setData] = useState([])
  const { selectedToken } = useContext(AppContext);
  
  useEffect(()=>{
    table();
    const interval = setInterval(async()=>{
      await table();
    },10000) // 10 seconds interval
    
    return () => clearInterval(interval);
  },[selectedToken])

  const table = async()=>{
    try {
      const walletAddress = tokenAddress[selectedToken];
      
      const config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: `https://deep-index.moralis.io/api/v2.2/wallets/${walletAddress}/history?chain=bsc&order=DESC`,
        headers: { 
          'X-API-Key': MORALIS_API_KEY
        }
      };

      const response = await axios.request(config);
      
      if(response.data && response.data.result) {
        const formattedData = response.data.result.map(tx => {
          let methodDisplay = '-';
          
          if (tx.method_label === 'collate_propagate_storage') {
            methodDisplay = 'Burn';
          } else if (!tx.method_label || tx.method_label === null) {
            methodDisplay = 'Mint';
          } else {
            methodDisplay = tx.method_label;
          }
          
          return {
            summary: tx.summary || 'Transaction',
            methodLabel: methodDisplay,
            Time: tx.block_timestamp,
            txhash: tx.hash,
            explorer: `https://bscscan.com/tx/${tx.hash}`
          };
        });
        
        setData(formattedData);
      }
    } catch (error) {
      console.error("Error fetching transactions:", error);
    }
  }

  const sliceTx = (tx) => {
    if (typeof tx != "string") {
      return;
    }
    const first = tx.slice(0, 10);
    const second = tx.slice(55);
    return first + "..." + second;
  };

  return (
    <div className=" m-t-5">
      <Table responsive>
        <thead>
          <tr>
            <th>Summary</th>
            <th>Method</th>
            <th>Time</th>
            <th>Hash</th>

          </tr>
        </thead>
        {data.map((data, index)=>{
          return <tbody key={index}>
          <tr>
            <td>{data.summary}</td>
            <td>{data.methodLabel}</td>
            <td>{moment((data.Time)).format('MMMM Do YYYY, h:mm:ss a')}</td>
            <td><a href={`${data.explorer}`} rel="noreferrer" target="_blank" >{sliceTx(data.txhash)}</a></td>
          </tr>
        </tbody>
        })}
      </Table>
    </div>
  );
} 
